const AppColors = {
  DarkBlue: '#00539d',
  LightBlue: '#00a6e8',
  Yellow: '#ffc905',
  Orange: '#f7991c',
  White: '#fff',
};

export default AppColors;
